var React = require('react');

function Basket (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M29.3 6.7c-.4-.4-.9-.7-1.5-.7H21L19.6.7c-.1-.5-.7-.8-1.2-.7-.5.1-.8.7-.7 1.2L18.9 6h-6.7l1-4.8c.1-.5-.2-1.1-.8-1.2-.5-.1-1.1.2-1.2.8l-1 5.2h-8c-.6 0-1.1.3-1.5.7-.4.5-.6 1.1-.5 1.7l2.6 14c.2 1 1 1.6 2 1.6h20.3c1 0 1.8-.7 2-1.6l2.6-14c.2-.6 0-1.2-.4-1.7zM25.2 22H4.8L2.2 8h17.2l.5 1.9c.1.4.5.7 1 .7h.3c.5-.1.8-.7.7-1.2L21.5 8h6.3l-2.6 14z"}));
}

Basket.defaultProps = {"width":"30","height":"24","viewBox":"0 0 30 24"};

module.exports = Basket;

Basket.default = Basket;
